import React from 'react';
import 'swiper/swiper-bundle.css';
import { ModuleItemInterface } from '../../../types/home.type';
import { useNavigate, useParams } from "react-router-dom";
import { POST_TYPES } from "../../../types/common.type";
import i18n from '../../../config/i18n';

interface VerticalListSectionProps {
  module: ModuleItemInterface;
}

const VerticalListSection: React.FC<VerticalListSectionProps> = ({ module }) => {
  const navigate = useNavigate();
  const { lang } = useParams<{ lang: string }>();
  const currentLang = lang || window.location.hash.split('/')[1] || i18n.options.fallbackLng;

  // Helper to get detail path by type
  const getDetailPath = (item: any) => {
    switch (item.type) {
      case POST_TYPES.MOVIES:
        return `/${currentLang}/movie/${item.slug}`;
      case POST_TYPES.COMIC:
        return `/${currentLang}/comic/${item.slug}`;
      case POST_TYPES.NOVEL:
        return `/${currentLang}/novel/${item.slug}`;
      default:
        return `/${currentLang}/movie/${item.slug}`;
    }
  };

  return (
    <div className="vertical-list-section">
      <h2 className="text-xl font-bold">{module.label}</h2>
      <div className="swiper">
        <div className="swiper-wrapper">
          {Array.isArray(module.items) &&
            module.items.map((item: any) => (
              <div
                key={item.id}
                className="swiper-slide cursor-pointer hover:bg-gray-800 rounded"
                onClick={() => navigate(getDetailPath(item))}
              >
                <p className="py-2">{item.name}</p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default VerticalListSection;
